// extracted by mini-css-extract-plugin
export default {"wrap":"SecurityModal_wrap__viJYC","modal":"SecurityModal_modal__Eut4f","inner":"SecurityModal_inner__S2Q6U"};